var map = {
	"./an-red.svg": "de7d",
	"./charge-active.svg": "d442",
	"./charge.svg": "c798",
	"./fork.svg": "e482",
	"./free-active.svg": "419a",
	"./free.svg": "6572",
	"./green.svg": "7c40",
	"./lock-close.svg": "140a",
	"./lock-open.svg": "d226",
	"./mark-s.svg": "e009",
	"./mark.svg": "1028",
	"./new-data.svg": "0297",
	"./orange.svg": "e31e",
	"./red.svg": "8bcf",
	"./report-svg.svg": "5197",
	"./yellow.svg": "259b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";